import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Typography, Alert } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import axios from 'axios';
import { AUTH_ENDPOINTS } from '../../constants/api';
import { ROUTES } from '../../constants/routes';
import {
  LoginContainer,
  LoginCard,
  StyledForm,
  LoginHeader,
  Logo,
  BeatingHeart,
  StyledTitle,
  StyledAlert,
  SignInButton,
  FooterText,
  CopyrightText
} from '../AdminLogin/styled';

const { Text, Paragraph } = Typography;

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async ({ email }) => {
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.post(AUTH_ENDPOINTS.FORGOT_PASSWORD, { email });
      if (data?.success) {
        setSubmitted(true);
      } else {
        setError(data?.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      const msg = err?.response?.data?.message || 'Unable to send reset email. Please try again.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginContainer>
      <LoginCard>
        <LoginHeader>
          <BeatingHeart />
          <Logo
            src="/bha-logo-full.png"
            alt="Black Heart Association"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <StyledTitle level={3}>Forgot your password?</StyledTitle>
          <Text type="secondary">Enter your email and we&apos;ll send you a reset link.</Text>
        </LoginHeader>

        {error && (
          <StyledAlert>
            <Alert message={error} type="error" showIcon />
          </StyledAlert>
        )}

        {submitted ? (
          <Paragraph style={{ textAlign: 'center', marginTop: 16 }}>
            If an account exists for that email, a password reset link has been sent.
            Please check your inbox (and spam folder).
            <br /><br />
            <Link to={ROUTES.LOGIN}>Back to sign in</Link>
          </Paragraph>
        ) : (
          <StyledForm
            form={form}
            name="forgot-password"
            onFinish={handleSubmit}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Please enter a valid email' }
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="Email address"
                size="large"
              />
            </Form.Item>

            <Form.Item>
              <SignInButton>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                  size="large"
                >
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </Button>
              </SignInButton>
            </Form.Item>

            <div style={{ textAlign: 'center', marginTop: 8 }}>
              <Link to={ROUTES.LOGIN}>Back to sign in</Link>
            </div>
          </StyledForm>
        )}

        <FooterText>
          <CopyrightText type="secondary">
            © 2025 Black Heart Association. All rights reserved.
          </CopyrightText>
        </FooterText>
      </LoginCard>
    </LoginContainer>
  );
};

export default ForgotPassword;
